import React from 'react';
import type { CSSProperties } from 'react';
import { DEFAULT_PRIORITIES, level_options } from './gen_config';
import type { GenRule, TierField } from './gen_config';

interface Props {
  rule: GenRule & { no_book_day_zero_override?: boolean };
  levels: string[] | null | undefined;
  priorities: string[] | null | undefined;
  disabled: boolean;
  on_change: (field: TierField, value: string | boolean) => void;
}

const SELECT: CSSProperties = {
  padding: '2px 6px',
  borderRadius: 6,
  border: '1px solid var(--input-border)',
  background: 'var(--input-bg)',
  color: 'var(--input-text)',
  margin: 0
};

// Level / Priority / Call window on one rule card.
function RuleTierControls({ rule, levels, priorities, disabled, on_change }: Props) {
  const id = `rule-tier-${rule.task_type}`;
  const prio_list = priorities && priorities.length ? priorities : DEFAULT_PRIORITIES;
  return (
    <span
      className="inline-flex items-center gap-4 flex-wrap text-xs"
      style={{ opacity: disabled ? 0.5 : 1, color: 'var(--text-muted)' }}
    >
      <label htmlFor={`${id}-level`} className="inline-flex items-center gap-1.5 font-medium">
        Level
        <select
          id={`${id}-level`}
          value={rule.level ?? ''}
          disabled={disabled}
          onChange={(e) => on_change('level', e.target.value)}
          style={SELECT}
        >
          {rule.level === null || rule.level === undefined ? <option value="">—</option> : null}
          {level_options(rule, levels).map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </label>
      <label htmlFor={`${id}-priority`} className="inline-flex items-center gap-1.5 font-medium">
        Priority
        <select
          id={`${id}-priority`}
          value={rule.priority || ''}
          disabled={disabled}
          onChange={(e) => on_change('priority', e.target.value)}
          style={SELECT}
        >
          {rule.priority ? null : <option value="">—</option>}
          {prio_list.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
      </label>
      <label
        htmlFor={`${id}-call-window`}
        className="inline-flex items-center gap-1.5 font-medium"
        title="Defer tasks created outside the student's local call window to the next window start."
      >
        <input
          id={`${id}-call-window`}
          type="checkbox"
          checked={!!rule.call_window}
          disabled={disabled}
          onChange={(e) => on_change('call_window', e.target.checked)}
        />
        Call window
      </label>
      {rule.no_book_day_zero_override ? (
        <span>Day 0 is always P0 with the call window.</span>
      ) : null}
    </span>
  );
}

export default RuleTierControls;
